import { useState } from "react";
import { X, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 backdrop-blur-sm border-b border-white/10">
      <div className="absolute inset-0 bg-gradient-to-r from-white/5 via-transparent to-white/5"></div>
      <div className="relative">
        <div className="container flex items-center justify-between py-3 px-4">
          <div className="flex-1 flex items-center justify-center gap-3">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1 border border-white/20">
              <Trophy className="h-4 w-4 text-yellow-300 animate-pulse" />
              <span className="text-xs font-semibold text-white tracking-wide uppercase">
                Success Story
              </span>
            </div>
            <p className="text-sm text-white/95 font-medium max-w-5xl text-center leading-relaxed">
              "I'm excited to share that I've passed the interviews and secured the <span className="font-bold text-yellow-200">E7 level</span>. I truly appreciate your guidance in ML system design and the mock sessions. I've benefited tremendously not only on the technical side but also in how to present my ideas clearly and persuasively. Thank you again for your time and support throughout this process." 
              <span className="text-yellow-200 font-semibold ml-2">- E7 from TikTok (secured offer at Meta)</span>
            </p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsVisible(false)}
            className="ml-4 h-8 w-8 p-0 rounded-full hover:bg-white/20 text-white/80 hover:text-white transition-all duration-200 hover:scale-110"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;